// this file is generated by update_shopify_store_data.py at 2026-11-03 20:15:32.385412
var courses = [
    {
        "course_id": "7D70F201-0286-F111-99B9-005056A77B46",
        "course_version": 2,
        "name": "Lifebeat Solutions - Behavioral Health Challenges",
        "course_type": 32,
        "author_information": "",
        "description": "Behavioral health challenges are becoming increasingly prevalent in acute care, requiring nurses to be equipped with specialized skills to manage patient aggression and suicide risk effectively. This Lifebeat Solutions program includes two courses that focus on practical, evidence-based strategies to ensure safety, promote healing, and support both patients and care teams.",
        "learning_objectives_html": "At the conclusion, participants should be able to:",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "2C7D9258-0186-F111-99B9-005056A77B46",
                "course_category_name": "Lifebeat Solutions - Behavioral Health Challenges - Curriculum",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": [
            {
                "course_id": "4B6E5A55-D270-F111-99B5-005056A7013F",
                "course_version": 2,
                "name": "Managing Patient Aggression in Acute Care Settings",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module equips nurses with de-escalation strategies, personal safety techniques, and post-incident protocols for managing aggressive behavior. Learners enhance safety for patients and staff while reducing physical and psychological harm in high-stress clinical environments.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses describe factors contributing to the rise of aggression in healthcare settings.</li>\r\n    <li>Nurses recognize early signs and triggers of escalating patient aggression.</li>\r\n    <li>Nurses apply de-escalation skills to manage aggressive patient behavior safely.</li>\r\n    <li>Nurses implement strategies to maintain team safety during aggressive incidents.</li>\r\n    <li>Nurses apply post-incident recovery, reporting, and reform practices following an aggressive event.</li>\r\n</ul>",
                "course_outline_html": "<h3>Addressing Patient Suicide Risk in Acute Care Settings</h3>\r\n<p>This course focuses on identifying and managing suicide risk in acute care environments using evidence-based approaches.</p>\r\n<strong>Lessons:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Understanding Suicide Risk Factors and Warning Signs</li>\r\n    <li>Comprehensive Suicide Risk Assessment</li>\r\n    <li>Safety Plans and Crisis Interventions</li>\r\n    <li>Treatment Approaches</li>\r\n    <li>Postvention and Ongoing Support</li>\r\n</ul>\r\n<strong>Criteria for Completion:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Complete all modules</li>\r\n    <li>Complete suicide risk simulation</li>\r\n    <li>Pass final assessment</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "014B7B43-B797-EB11-80DE-005056B160AF",
                        "course_category_name": "Patient Monitoring",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5936B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Behavioral Health Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0A2A275A-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "323AB59C-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Behavioral Health Challenges [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "04403C75-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Behavioral Health Challenges",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8D3F3C75-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "411A8674-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Violence & Abuse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF67E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "A9F0251D-B170-F111-99B5-005056A7013F",
                "course_version": 2,
                "name": "Addressing Patient Suicide Risk in Acute Care",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module trains nurses in identifying suicide risk, conducting safety planning, and coordinating multidisciplinary care. Learners use evidence-based screening tools and escalation pathways \u2014 strengthening early intervention and protecting vulnerable patients through proactive behavioral health vigilance.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses identify suicide risk factors and warning signs in the acute care setting.</li>\r\n    <li>Nurses conduct a comprehensive suicide risk assessment using evidence-based tools.</li>\r\n    <li>Nurses develop safety plans and implement crisis intervention strategies.</li>\r\n    <li>Nurses apply evidence-based treatment approaches for patients at risk for suicide.</li>\r\n    <li>Nurses implement postvention and ongoing support strategies following a suicide-related event.</li>\r\n</ul>",
                "course_outline_html": "<h3>Quality Improvement &amp; Clinical Audit in Nursing Practice</h3>\r\n<p>This course develops the nurse&rsquo;s ability to evaluate clinical practice, identify gaps in care, and contribute to continuous quality improvement initiatives that enhance patient safety and outcomes.</p>\r\n<strong>Lessons:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Introduction to Quality Improvement in Healthcare</li>\r\n    <li>Principles of Clinical Audit and Performance Measurement</li>\r\n    <li>Identifying Gaps in Clinical Practice</li>\r\n    <li>Implementing Evidence-Based Improvement Strategies</li>\r\n    <li>Monitoring Outcomes and Sustaining Improvements</li>\r\n</ul>\r\n<strong>Criteria for Completion:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Complete all modules</li>\r\n    <li>Participate in a quality improvement or audit simulation</li>\r\n    <li>Submit a basic improvement action plan</li>\r\n    <li>Pass final assessment quiz</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "04403C75-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Behavioral Health Challenges",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "323AB59C-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Behavioral Health Challenges [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5936B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Behavioral Health Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "45A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Psychiatry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF67E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ED7E45AB-9782-E211-B22E-0015171C1A75",
                        "course_category_name": "Psychiatric Disorders",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8D3F3C75-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "014B7B43-B797-EB11-80DE-005056B160AF",
                        "course_category_name": "Patient Monitoring",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            }
        ]
    }
];